export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1769016760743-eb89fdfdd32e",
  windows: "https://images.unsplash.com/photo-1781328487854-07a1600ab0a8",
  doors: "https://images.unsplash.com/photo-1613544723301-176686aa9f09",
  garage: "https://images.unsplash.com/photo-1783125127341-81112b795c23",
  sliding: "https://images.unsplash.com/photo-1783431286543-a2932d8017e9",
  about: "https://images.unsplash.com/photo-1769852578076-b194ad2c08b6",
  primes: "https://images.unsplash.com/photo-1758448756207-54505680d130",
  gallery: [
    { src: "https://images.unsplash.com/photo-1769852578076-b194ad2c08b6", type: { fr: "Rénovation complète", nl: "Volledige renovatie" }, loc: "Gent", span: "lg:col-span-7", h: "h-[62vh]" },
    { src: "https://images.unsplash.com/photo-1758448756207-54505680d130", type: { fr: "Villa neuve", nl: "Nieuwbouwvilla" }, loc: "Waterloo", span: "lg:col-span-5", h: "h-[62vh]" },
    { src: "https://images.unsplash.com/photo-1668911494256-becf9fea265b", type: { fr: "Extension vitrée", nl: "Glazen uitbreiding" }, loc: "Antwerpen", span: "lg:col-span-5", h: "h-[58vh]" },
    { src: "https://images.unsplash.com/photo-1783125127341-81112b795c23", type: { fr: "Façade & garage", nl: "Gevel & garage" }, loc: "Namur", span: "lg:col-span-7", h: "h-[58vh]" },
  ],
  products: {
    fenetres: {
      hero: "https://images.unsplash.com/photo-1781328487854-07a1600ab0a8",
      gallery: [
        "https://images.unsplash.com/photo-1781328487854-07a1600ab0a8",
        "https://images.unsplash.com/photo-1783431286543-a2932d8017e9",
        "https://images.unsplash.com/photo-1758448756207-54505680d130",
      ],
    },
    portes: {
      hero: "https://images.unsplash.com/photo-1613544723301-176686aa9f09",
      gallery: [
        "https://images.unsplash.com/photo-1613544723301-176686aa9f09",
        "https://images.unsplash.com/photo-1668911494256-becf9fea265b",
        "https://images.unsplash.com/photo-1769852578076-b194ad2c08b6",
      ],
    },
    garage: {
      hero: "https://images.unsplash.com/photo-1783125127341-81112b795c23",
      gallery: [
        "https://images.unsplash.com/photo-1783125127341-81112b795c23",
        "https://images.unsplash.com/photo-1769016760743-eb89fdfdd32e",
        "https://images.unsplash.com/photo-1758448756207-54505680d130",
      ],
    },
    clotures: {
      hero: "https://images.unsplash.com/photo-1645005047809-8a7740441037",
      gallery: [
        "https://images.unsplash.com/photo-1645005047809-8a7740441037",
        "https://images.unsplash.com/photo-1645005047304-223bb24b355a",
        "https://images.unsplash.com/photo-1602320549763-3e0b12d50ab9",
      ],
    },
    accessoires: {
      hero: "https://images.unsplash.com/photo-1757125505217-f4457bb220ed",
      gallery: [
        "https://images.unsplash.com/photo-1757125505217-f4457bb220ed",
        "https://images.unsplash.com/photo-1592924271903-1e4b1a1ae20f",
        "https://images.unsplash.com/photo-1639310812309-9d2a6150de37",
      ],
    },
    pergolas: {
      hero: "https://images.unsplash.com/photo-1633354747567-e0682586f082",
      gallery: [
        "https://images.unsplash.com/photo-1633354747567-e0682586f082",
        "https://images.unsplash.com/photo-1778576866129-ecedf7db8525",
        "https://images.unsplash.com/photo-1707190202828-a80033dbec21",
      ],
    },
  },
  fenetres: {
    hero: "https://images.unsplash.com/photo-1613244288805-020d7d11c655",
    pvc: "https://images.unsplash.com/photo-1732633354392-ff3c861a470f",
    alu: "https://images.unsplash.com/photo-1668451947822-1710f53bd0d5",
    systems: [
      "/systemes/ideal-4000.png",
      "/systemes/ideal-8000.png",
      "/systemes/aluprof-mb-86.png",
    ],
    perf: "https://images.unsplash.com/photo-1762810951632-68c9f197cf33",
    colours: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2",
  },
  garagePage: {
    systems: [
      "/systemes/garage-1.png",
      "/systemes/garage-2.png",
      "/systemes/garage-3.png",
    ],
  },
  cloturesPage: {
    systems: [
      "/systemes/cloture-1.png",
      "/systemes/cloture-2.png",
      "/systemes/cloture-3.png",
    ],
  },
  accessoiresPage: {
    systems: [
      "/systemes/acc-1.png",
      "/systemes/acc-2.png",
      "/systemes/acc-3.png",
    ],
  },
};

export const RADIUS = "rounded-[14px]";

export const PRODUCT_ORDER = [
  { key: "fenetres", slug: "fenetres" },
  { key: "garage", slug: "portes-de-garage" },
  { key: "clotures", slug: "clotures" },
  { key: "accessoires", slug: "accessoires" },
];

export const SLUG_TO_KEY = {
  fenetres: "fenetres",
  "portes-de-garage": "garage",
  clotures: "clotures",
  accessoires: "accessoires",
};
